import { getDeviceType } from 'common/utils/system'

export const pxToViewport = (value: number | string) => {
  const viewportWidth = getDeviceType() === 'mobile' ? 375 : 1920
  const _value = typeof value === 'number' ? value : Number(value.replace(`px`, ''))
  return `${(_value * 100 / viewportWidth).toFixed(5)}vw`

} 